import _slicedToArray from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { makeUseContext } from "../utils.js";
var LightboxStateContext = React.createContext(null);
export var useLightboxState = makeUseContext("useLightboxState", "LightboxStateContext", LightboxStateContext);

var reducer = function reducer(slidesCount) {
  return function (state, action) {
    var _a;

    return action.increment !== undefined || action.animationDuration !== undefined ? {
      currentIndex: ((state.currentIndex + (action.increment || 0)) % slidesCount + slidesCount) % slidesCount,
      globalIndex: state.globalIndex + (action.increment || 0),
      animationDuration: (_a = action.animationDuration) !== null && _a !== void 0 ? _a : state.animationDuration
    } : state;
  };
};

export var LightboxStateProvider = function LightboxStateProvider(_ref) {
  var initialIndex = _ref.initialIndex,
      slidesCount = _ref.slidesCount,
      children = _ref.children;

  var _React$useReducer = React.useReducer(reducer(slidesCount), {
    currentIndex: initialIndex,
    globalIndex: initialIndex,
    animationDuration: 0
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var context = React.useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return React.createElement(LightboxStateContext.Provider, {
    value: context
  }, children);
};